/* Petit Cochon – Produktseite (aus sections/main-product.liquid ausgelagert, damit die Datei unter der Shopify-Grenze von 256 KB bleibt) */
  (() => {
    if (window.pcProductUiInit) return;
    window.pcProductUiInit = true;

    /* Fenster (Auszeichnungen) */
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-pc-dialog]');
      if (opener) {
        const dlg = document.querySelector(opener.dataset.pcDialog);
        if (dlg && dlg.showModal) dlg.showModal();
        return;
      }
      if (e.target.closest('[data-pc-close]')) e.target.closest('dialog')?.close();
      else if (e.target.tagName === 'DIALOG' && e.target.classList.contains('pc-dialog')) e.target.close();
    });

    /* Passt dazu: in den Warenkorb ohne Seitenwechsel */
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-pc-add]');
      if (!form) return;
      e.preventDefault();
      const btn = form.querySelector('button');
      const label = form.closest('.pc-pairs')?.dataset.addLabel || btn.textContent;
      const id = Number(form.querySelector('[name="id"]').value);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: [{ id, quantity: 1 }] };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
        cart.setActiveElement?.(document.activeElement);
      }
      btn.disabled = true;
      try {
        const res = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (data.status) {
          btn.textContent = data.description || 'Nicht verfügbar';
        } else {
          const item = (data.items && data.items[0]) || data;
          if (cart && typeof cart.renderContents === 'function') {
            cart.classList.remove('is-empty');
            cart.renderContents({ ...item, sections: data.sections });
          }
          btn.textContent = '✓ Hinzugefügt';
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pc-pairs' });
        }
      } catch (err) {
        btn.textContent = 'Fehler – bitte erneut versuchen';
      } finally {
        const kept = form.hasAttribute('data-pc-keep') && btn.textContent.startsWith('✓');
        if (kept) btn.textContent = '✓ Liegt im Warenkorb';
        else setTimeout(() => { btn.disabled = false; btn.textContent = label; }, 2500);
      }
    });

    /* Geschenk mitbestellen: nach „In den Warenkorb“ das Geschenk dazulegen, wenn das Häkchen gesetzt ist */
    const addGift = async (line) => {
      const giftId = Number(line.dataset.pcGift);
      const check = line.querySelector('[data-pc-gift-check]');
      if (!giftId || !check || !check.checked) return;
      try {
        const cartNow = await (await fetch((window.routes?.cart_url || '/cart') + '.js')).json();
        if ((cartNow.items || []).some((i) => i.variant_id === giftId)) { markGift(line); return; }
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { items: [{ id: giftId, quantity: 1 }] };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }
        const res = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (data.status) return;
        const item = (data.items && data.items[0]) || data;
        if (cart && typeof cart.renderContents === 'function' && data.sections) cart.renderContents({ ...item, sections: data.sections });
        markGift(line);
      } catch (e) { /* Geschenk konnte nicht hinzugefügt werden – Hauptartikel bleibt im Warenkorb */ }
    };
    const markGift = (line) => {
      const lbl = line.querySelector('.pc-gift-line__check');
      if (lbl) lbl.outerHTML = '<span class="pc-gift-line__done">✓ im Warenkorb</span>';
    };
    const initGift = () => {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || window.pcGiftSub) return;
      window.pcGiftSub = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (!event || event.source !== 'product-form') return;
        document.querySelectorAll('.pc-gift-line[data-pc-gift]').forEach((line) => {
          if (line.closest('product-info, .product') ) addGift(line);
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGift);
    else initGift();

    /* Passt dazu: Shopify-Empfehlungen nachladen, wenn keine Produkte zugeordnet sind */
    const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const money = (cents) => {
      try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100); }
      catch { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
    };
    const img = (src, w) => src ? (src.startsWith('//') ? 'https:' + src : src) + (src.includes('?') ? '&' : '?') + 'width=' + w : '';
    const loadPairs = async (box) => {
      const pid = box.dataset.productId;
      const max = Number(box.dataset.max || 4);
      const base = box.dataset.recUrl || '/recommendations/products';
      let products = [];
      for (const intent of ['complementary', 'related']) {
        try {
          const r = await fetch(`${base}.json?product_id=${pid}&limit=${max + 1}&intent=${intent}`);
          const j = await r.json();
          products = (j.products || []).filter((p) => String(p.id) !== String(pid) && p.available);
        } catch { products = []; }
        if (products.length) break;
      }
      products = products.slice(0, max);
      if (!products.length) { box.hidden = true; return; }
      const label = esc(box.dataset.addLabel || '+ Hinzufügen');
      box.querySelector('.pc-pairs__list').innerHTML = products.map((p) => {
        const vars = (p.variants || []).filter((v) => v.available);
        const sel = vars.length > 1
          ? `<select name="id" class="pc-pairs__select" aria-label="Variante wählen">${vars.map((v) => `<option value="${v.id}">${esc(v.title)}</option>`).join('')}</select>`
          : `<input type="hidden" name="id" value="${vars[0] ? vars[0].id : ''}">`;
        const from = p.price_varies ? 'ab ' : '';
        return `<li class="pc-pairs__item">
          <a href="${esc(p.url)}" class="pc-pairs__media">${p.featured_image ? `<img src="${esc(img(p.featured_image, 300))}" alt="${esc(p.title)}" loading="lazy">` : ''}</a>
          <a href="${esc(p.url)}" class="pc-pairs__name">${esc(p.title)}</a>
          <span class="pc-pairs__price">${from}${money(p.price_min ?? p.price)}</span>
          <form class="pc-pairs__form" data-pc-add>${sel}<button type="submit" class="pc-pairs__add">${label}</button></form>
        </li>`;
      }).join('');
      box.hidden = false;
    };
    const initPairs = () => document.querySelectorAll('.pc-pairs[data-auto="true"]:not([data-loaded])').forEach((box) => {
      box.dataset.loaded = 'true';
      loadPairs(box);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPairs);
    else initPairs();
    document.addEventListener('shopify:section:load', initPairs);
  })();

  /* Material-Umschalter: wischen, mit der Maus ziehen oder Pfeile – auch auf dem Computer.
     Funktioniert auch, wenn das Theme den Produktbereich neu lädt (Größe/Farbe wechseln). */
  if (!window.pcMaterialSlider) {
    window.pcMaterialSlider = true;

    const pcMsUpdate = (track) => {
      const list = track.querySelector('.pc-ms__list');
      if (!list) return;
      const prev = track.querySelector('.pc-ms__arrow--prev');
      const next = track.querySelector('.pc-ms__arrow--next');
      const max = list.scrollWidth - list.clientWidth;
      const more = max > 2;
      if (prev) prev.hidden = !more || list.scrollLeft <= 2;
      if (next) next.hidden = !more || list.scrollLeft >= max - 2;
      track.classList.toggle('has-more', more && list.scrollLeft < max - 2);
    };

    const pcMsDone = new WeakSet();
    const pcMsSetup = (track) => {
      if (pcMsDone.has(track)) { pcMsUpdate(track); return; }
      const list = track.querySelector('.pc-ms__list');
      if (!list) return;
      pcMsDone.add(track);
      list.addEventListener('scroll', () => pcMsUpdate(track), { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(() => pcMsUpdate(track)).observe(list);

      /* Mausrad senkrecht → waagerecht, nur wenn es noch etwas zu scrollen gibt */
      list.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        const max = list.scrollWidth - list.clientWidth;
        if (max <= 2) return;
        const goingRight = e.deltaY > 0;
        if ((goingRight && list.scrollLeft >= max - 2) || (!goingRight && list.scrollLeft <= 2)) return;
        e.preventDefault();
        list.scrollBy({ left: e.deltaY, behavior: 'auto' });
      }, { passive: false });

      /* Aktuelles Material sichtbar machen */
      const cur = list.querySelector('.is-current');
      if (cur) {
        const li = cur.closest('.pc-ms__item');
        if (li && li.offsetLeft + li.offsetWidth > list.clientWidth) list.scrollLeft = li.offsetLeft - 8;
      }
      pcMsUpdate(track);
      setTimeout(() => pcMsUpdate(track), 300);
    };

    const pcMsInitAll = () => document.querySelectorAll('.pc-ms__track').forEach(pcMsSetup);

    /* Pfeile: Klick auf der ganzen Seite abfangen (klappt auch nach dem Neuladen des Bereichs) */
    document.addEventListener('click', (e) => {
      const arrow = e.target.closest && e.target.closest('.pc-ms__arrow');
      if (!arrow) return;
      e.preventDefault();
      const track = arrow.closest('.pc-ms__track');
      const list = track && track.querySelector('.pc-ms__list');
      if (!list) return;
      const step = Math.max(list.clientWidth * 0.8, 120);
      list.scrollBy({ left: arrow.classList.contains('pc-ms__arrow--prev') ? -step : step, behavior: 'smooth' });
    });

    /* Mit der Maus ziehen (auf Handy/Tablet scrollt der Finger ohnehin) */
    let pcDrag = null;
    document.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      const list = e.target.closest && e.target.closest('.pc-ms__list');
      if (!list || e.target.closest('.pc-ms__arrow')) return;
      pcDrag = { list, startX: e.clientX, startLeft: list.scrollLeft, moved: false };
    });
    window.addEventListener('pointermove', (e) => {
      if (!pcDrag) return;
      const dx = e.clientX - pcDrag.startX;
      if (!pcDrag.moved && Math.abs(dx) > 5) { pcDrag.moved = true; pcDrag.list.classList.add('is-dragging'); }
      if (pcDrag.moved) pcDrag.list.scrollLeft = pcDrag.startLeft - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!pcDrag) return;
      const { list, moved } = pcDrag;
      pcDrag = null;
      if (moved) {
        setTimeout(() => list.classList.remove('is-dragging'), 0);
        list.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); }, { capture: true, once: true });
      }
    });

    window.addEventListener('resize', pcMsInitAll);
    window.addEventListener('load', pcMsInitAll);
    document.addEventListener('shopify:section:load', pcMsInitAll);

    /* Neu eingesetzte Slider erkennen (Theme lädt den Produktbereich bei Variantenwechsel neu) */
    let pcMsQueued = false;
    new MutationObserver(() => {
      if (pcMsQueued) return;
      pcMsQueued = true;
      requestAnimationFrame(() => { pcMsQueued = false; pcMsInitAll(); });
    }).observe(document.documentElement, { childList: true, subtree: true });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pcMsInitAll); else pcMsInitAll();
  }
